
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import PageLoader from '@/core/components/PageLoader.vue';
import ProfileTopbar from '@/profile/components/ProfileTopbar.vue';
import PageError from '@/core/components/PageError.vue';
import ProfileNav from '@/profile/components/ProfileNav.vue';
import ProfileMobileNav from '@/profile/components/ProfileMobileNav.vue';

const profileNamespace = namespace('profile');

@Component({
	components: {
		ProfileNav,
		ProfileMobileNav,
		PageLoader,
		ProfileTopbar,
		PageError,
	},
})
export default class ProfileLayout extends Vue {
	@profileNamespace.State('isPageLoaderShown')
	public isPageLoaderShown!: boolean;

	@profileNamespace.State('isPageErrorShown')
	public isPageErrorShown!: boolean;

	public isIframe: boolean = false;

	mounted() {
		if (window !== window.parent) {
			this.isIframe = true;
		}
	}
}

